import { Heading, Spacer, useToast, VStack } from '@chakra-ui/react';
import { useLoginMutation } from '@partiu/api/auth/hooks';
import { useForm } from 'react-hook-form';
import { LuMoveRight } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../../../../packages/ui/components/atoms/Button';
import { MaskedInput } from '../../../../../../packages/ui/components/atoms/Input';
import { useProfile } from '../../../../../../packages/ui/contexts/ProfileProvider';
import { useTheme } from '../../../../../../packages/ui/contexts/ThemeProvider';

export function SurfLoginForm({ setExClient }: { setExClient?: (value: boolean) => void }) {
  const navigate = useNavigate();
  const toast = useToast({ isClosable: true });
  const { name, integratedLogin, id, colors, exClientModule } = useTheme();
  const { updateProfile } = useProfile();
  const { register, handleSubmit } = useForm<{
    username: string;
  }>();

  const loginMutation = useLoginMutation({
    integratedLogin,
    agreementId: String(id),
    onSuccess() {
      updateProfile({});
      navigate('/');
    },
    onError(error) {
      toast({ title: 'Oops!', description: error, status: 'error' });
    },
  });

  return (
    <VStack w={'100%'} align={'flex-start'} spacing={2}>
      <Heading
        paddingTop={'20px'}
        paddingBottom={'10px'}
        fontWeight={500}
        letterSpacing={'-0.2rem'}
        fontFamily={'Montserrat'}
        fontSize={'38px'}
      >
        Login
      </Heading>
      <form
        onSubmit={handleSubmit(({ username }) => loginMutation.mutate({ username: username.replace(/\D/g, '') }))}
        style={{ width: '100%' }}
      >
        <VStack w={'100%'} spacing={7}>
          <MaskedInput mask={'(99) 9 9999-9999'} label="Telefone" {...register('username')} />
          <Heading
            alignSelf={'flex-end'}
            cursor={'pointer'}
            onClick={() => {
              if (toast.isActive('password-recovery')) return;

              toast({
                id: 'password-recovery',
                title: 'Recuperação de Senha',
                description: `Para recuperar a senha da sua conta entre em contato com a ${name}.`,
              });
            }}
            textDecor={'underline'}
            fontWeight={500}
            fontSize={'14px'}
            marginTop={'-20px'}
          >
            Esqueci minha senha
          </Heading>
          <Button type="submit" isLoading={loginMutation.isLoading} rightIcon={<LuMoveRight fontSize={'24px'} />}>
            Entrar
          </Button>
          {exClientModule && (
            <Button
              backgroundColor="transparent"
              borderColor={colors.primaryColor}
              borderWidth={1}
              color={colors.primaryColor}
              _hover={{ backgroundColor: colors.primaryColor, color: 'white' }}
              onClick={() => setExClient && setExClient(true)}
              isLoading={loginMutation.isLoading}
            >
              Entrar como Ex-Cliente
            </Button>
          )}
        </VStack>
      </form>
      <Spacer />
    </VStack>
  );
}
